import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BlockContainer = styled.div`
  background-color: hsl(${({ tint }) => tint}, 40%, 91%);
  border: 1px solid hsl(${({ tint }) => tint}, 35%, 70%);
  color: hsl(${({ tint }) => tint}, 22%, 48%);
  border-radius: 2px;
  padding: 0.5em;
  padding-top: 1.5em;
  margin: 1em 0;
  margin-top: 2em;
  position: relative;
`

const IconContainer = styled.div`
  border: 1px solid hsl(${({ tint }) => tint}, 35%, 70%);
  background-color: hsl(${({ tint }) => tint}, 40%, 91%);
  height: 40px;
  width: 40px;
  border-radius: 20px;
  position: absolute;
  top: -20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BlockHeader = styled.div`
  font-weight: bold;
  padding-bottom: 4px;
  border-bottom: 1px solid hsl(${({ tint }) => tint}, 35%, 70%);
`

const Block = ({ header, icon, tint, children }) => (
  <BlockContainer tint={tint}>
    <IconContainer tint={tint}>
      <FontAwesomeIcon icon={icon} />
    </IconContainer>
    <BlockHeader tint={tint}>{header}</BlockHeader>
    {children}
  </BlockContainer>
)

export default Block



// WEBPACK FOOTER //
// ./src/components/Block.js